module.exports = __webpack_public_path__ + "static/DSC04663-5e9cdc7e5a50e7be28258d98f5604174.jpg";